export const IMPERSONATED_BANNER_HEIGHT: number = 20;

export const ACTIVE_ROOMS_BANNER_HEIGHT: number = 50;

export const ICONS = {
  course: 'CollectionsBookmark',
  session: 'AutoStories',
};
